import type { Token, VToken } from 'types';

type TokenWithDisplaySymbol = (Token | VToken) & { displaySymbol?: string };

export const getTokenDisplaySymbol = (token: TokenWithDisplaySymbol) =>
  token.displaySymbol ?? token.symbol;
